// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownComponent } from './dropdown/dropdown.component';
import { DropdownItemComponent } from './dropdown-item/dropdown-item.component';
import { DropdownContentComponent } from './dropdown-content/dropdown-content.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    DropdownComponent,
    DropdownItemComponent,
    DropdownContentComponent,
  ],
  declarations: [
    DropdownComponent,
    DropdownItemComponent,
    DropdownContentComponent,
  ],
})
export class DropdownModule {
}
